import DefaultResetForm from '@/components/DefaultResetForm';
import { CustomTextField } from '@/components/Formik/CustomTextField';
import { useUser } from '@/contexts/AuthContext';
import { api } from '@/services/apiClient';
import { User } from '@/types/api/users';
import { resetEmail } from '@/validators/resetUsersInfo';
import { Box, Typography } from '@mui/material';
import { FormikValues } from 'formik';
import { IModalSuccessData } from '.';

interface ResetEmail {
  onSuccess: (value: IModalSuccessData) => void;
  handleClose: () => void;
}

const ResetEmail = ({ onSuccess, handleClose }: ResetEmail) => {
  const { user, updateUserData } = useUser();

  const handleSubmitResetEmailForm = async (values: FormikValues) => {
    const { data } = await api.put<User>('/auth/users/me/', {
      cpf: user?.cpf,
      name: user?.name,
      email: values.email,
      username: user?.username,
    });

    onSuccess({
      isOpen: true,
      text: 'Seu e-mail foi alterado com sucesso!',
    });
    updateUserData(data);
  };

  return (
    <DefaultResetForm
      title="Informe seu email"
      onSubmit={handleSubmitResetEmailForm}
      handleCancel={handleClose}
      handleClose={handleClose}
      validationSchema={resetEmail}
      initialValues={{
        email: user.email,
      }}
    >
      <Box sx={{ display: 'grid' }}>
        <CustomTextField label="E-mail *" name="email" variant="standard" />
        <Typography variant="caption" sx={{ marginTop: '2px', opacity: '50%' }}>
          Você pode usar este endereço de e-mail para receber cotações ou
          recuperar sua senha
        </Typography>
      </Box>
    </DefaultResetForm>
  );
};

export default ResetEmail;
